import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Badge, Card, CardBody, Container, Spinner, Table } from "reactstrap";

import { apiFetch, API } from "../../services/api";
import { ANGLES, localeLabel, statusInfo } from "../../helpers/studioStory";

const fmtDate = (d) => {
    const date = new Date(d);
    return isNaN(date.getTime()) || date.getFullYear() < 1971 ? "—" : date.toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
};
const angleLabel = (mode, angle) => ((ANGLES[mode] || []).find((a) => a.id === angle) || {}).label || angle;

// Historique des stories du Studio (les 50 dernières).
export function StoryHistory() {
    const [stories, setStories] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        apiFetch(API.back + "/studio-stories", { method: "GET", market: false })
            .then((res) => { if (!res.ok) throw new Error("HTTP " + res.status); return res.json(); })
            .then((list) => setStories(Array.isArray(list) ? list : []))
            .catch((e) => { setError("Historique indisponible (" + e.message + ")."); setStories([]); });
    }, []);

    return (
        <Container fluid className="p-0">
            <h1 className="h3 mb-3">Historique des stories</h1>
            <Card>
                <CardBody>
                    {error && <Alert color="danger">{error}</Alert>}
                    {!stories ? <Spinner size="sm" /> : stories.length === 0 ? <div>Aucune story pour l'instant. <Link to="/studio/new">Créer la première</Link>.</div> : (
                        <Table size="sm" hover responsive>
                            <thead><tr><th>Créée le</th><th>Type</th><th>Langue</th><th>Angle</th><th>Thème</th><th>Produits</th><th>Statut</th><th>Par</th><th /></tr></thead>
                            <tbody>
                                {stories.map((s) => {
                                    const info = statusInfo(s.status);
                                    return (
                                        <tr key={s.id}>
                                            <td>{fmtDate(s.createdAt)}</td>
                                            <td>{s.mode === "general" ? "Généraliste" : "Produit"}</td>
                                            <td>{localeLabel(s.locale)}</td>
                                            <td>{angleLabel(s.mode, s.angle)}</td>
                                            <td>{s.theme}</td>
                                            <td className="small">{(s.productIds || []).join(", ")}</td>
                                            <td><Badge color={info.color}>{info.label}</Badge></td>
                                            <td className="small">{s.createdBy || "—"}</td>
                                            <td><Link to={"/studio/story/" + s.id}>Ouvrir</Link></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    )}
                </CardBody>
            </Card>
        </Container>
    );
}
